module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    ref: "wrapper",
    staticClass: "wrapper",
    style: ({
      height: _vm.wrapperHeight + 'px'
    })
  }, [(_vm.list.length > 0) ? _c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    ref: "viewBox",
    staticClass: "live-room",
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "50"
    }
  }, [(_vm.top) ? _c('li', {
    staticClass: "flex top"
  }, [_c('div', {
    staticClass: "left"
  }, [_c('div', {
    staticClass: "avatar",
    style: ({
      backgroundImage: ("url(" + (_vm.top.userIcon ? _vm.top.userIcon: _vm.head) + ")")
    })
  }), _vm._v(" "), _c('div', {
    staticClass: "job"
  }, [_vm._v(_vm._s(_vm.top.userType === 'host' ? '主持人' : '嘉宾'))])]), _vm._v(" "), _c('div', {
    staticClass: "right"
  }, [_c('div', {
    staticClass: "flex-default"
  }, [_c('div', {
    staticClass: "name ellipsis"
  }, [_vm._v("\n                        " + _vm._s(_vm.top.userName) + "\n                        "), _c('div', {
    staticClass: "i"
  }, [_vm._v("置顶")])]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(_vm.top.date))))])]), _vm._v(" "), _c('div', {
    staticClass: "content",
    domProps: {
      "innerHTML": _vm._s(_vm.top.content)
    }
  }), _vm._v(" "), (_vm.top && !!_vm.top.medias && _vm.top.medias.type === 'video') ? _c('div', {
    staticClass: "video-wrap content video-content"
  }, [_c('p', {
    staticClass: "common-video-box"
  }, [_c('video', {
    staticClass: "videoClass common-video live-top-video",
    staticStyle: {
      "object-fit": "fill"
    },
    attrs: {
      "id": _vm.top.id,
      "src": _vm.top.medias.url,
      "poster": _vm.top.medias.coverImg,
      "x-webkit-airplay": "allow",
      "controlslist": "nodownload",
      "x5-video-player-fullscreen": "false",
      "x5-video-orientation": "portraint",
      "x5-video-player-type": "h5-page",
      "webkit-playsinline": "",
      "controls": "",
      "playsinline": "",
      "preload": "auto"
    }
  })])]) : _vm._e(), _vm._v(" "), (!!_vm.top && !!_vm.top.medias && _vm.top.medias.type === 'audio') ? _c('div', {
    staticClass: "content"
  }, [_c('audio', {
    staticClass: "audioClass",
    attrs: {
      "src": _vm.top.medias.url,
      "controls": "",
      "controlslist": "nodownload"
    }
  })]) : (!!_vm.top.image) ? _c('div', {
    staticClass: "content"
  }, [_c('img', {
    staticStyle: {
      "width": "60vw",
      "height": "35vw"
    },
    attrs: {
      "src": _vm.top.image,
      "alt": ""
    },
    on: {
      "click": function($event) {
        return _vm.showGallary(_vm.top.image)
      }
    }
  })]) : _vm._e(), _vm._v(" "), _vm._l((_vm.top.replies), function(replie) {
    return _c('div', {
      key: replie.id,
      staticClass: "reply"
    }, [_c('p', [_c('span', [_vm._v("回复：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(replie.userName))]), _vm._v("\n                        " + _vm._s(replie.content) + "\n                        "), (replie.image) ? _c('img', {
      staticStyle: {
        "width": "60vw",
        "height": "35vw"
      },
      attrs: {
        "src": replie.image,
        "alt": ""
      },
      on: {
        "click": function($event) {
          return _vm.showGallary(replie.image)
        }
      }
    }) : _vm._e()])])
  })], 2)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.list), function(item) {
    return _c('li', {
      key: item.id,
      staticClass: "flex"
    }, [_c('div', {
      staticClass: "left"
    }, [_c('div', {
      staticClass: "avatar",
      style: ({
        backgroundImage: ("url(" + (item.userIcon ? item.userIcon: _vm.head) + ")")
      })
    }), _vm._v(" "), _c('div', {
      staticClass: "job"
    }, [_vm._v(_vm._s(item.userType === 'host' ? '主持人' : '嘉宾'))])]), _vm._v(" "), _c('div', {
      staticClass: "right"
    }, [_c('div', {
      staticClass: "flex-default"
    }, [_c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(item.userName))]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(item.date))))])]), _vm._v(" "), _c('div', {
      staticClass: "content",
      domProps: {
        "innerHTML": _vm._s(item.content)
      }
    }), _vm._v(" "), (!!item.image) ? _c('div', {
      staticClass: "content"
    }, [_c('img', {
      staticStyle: {
        "width": "60vw",
        "height": "35vw"
      },
      attrs: {
        "src": item.image
      },
      on: {
        "click": function($event) {
          return _vm.showGallary(item.image)
        }
      }
    })]) : _vm._e(), _vm._v(" "), (!!item && !!item.medias && item.medias.type === 'video') ? _c('div', {
      staticClass: "video-wrap content video-content"
    }, [_c('p', {
      staticClass: "common-video-box"
    }, [_c('video', {
      staticClass: "videoClass common-video",
      staticStyle: {
        "object-fit": "fill"
      },
      attrs: {
        "src": item.medias.url,
        "poster": item.medias.coverImg,
        "controlslist": "nodownload",
        "x-webkit-airplay": "allow",
        "webkit-playsinline": "playsinline",
        "x5-video-orientation": "portraint",
        "x5-video-player-type": "h5-page",
        "x5-video-player-fullscreen": "false",
        "webkit-appearance": "none",
        "playsinline": "",
        "controls": "",
        "preload": "auto"
      }
    })])]) : _vm._e(), _vm._v(" "), (!!item && !!item.medias && item.medias.type === 'audio') ? _c('div', {
      staticClass: "content"
    }, [_c('audio', {
      staticClass: "audioClass",
      attrs: {
        "src": item.medias.url,
        "controls": "",
        "controlslist": "nodownload"
      }
    })]) : _vm._e(), _vm._v(" "), _vm._l((item.replies), function(replie) {
      return _c('div', {
        key: replie.id,
        staticClass: "reply"
      }, [_c('p', [_c('span', [_vm._v("回复：")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(replie.userName))]), _vm._v("\n                        " + _vm._s(replie.content) + "\n                    ")])])
    })], 2)])
  })], 2) : _c('div', {
    class: ['null-data', 'share-null-data']
  }), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "loading"
  }, [_c('mt-spinner', {
    attrs: {
      "type": "fading-circle"
    }
  }), _vm._v("加载中...\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
    staticClass: "loading"
  }, [_vm._v("已显示全部内容")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-239e7c7c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/live2/live-room.vue
// module id = 839
// module chunks = 2